// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"642":"11276b62bb934e4d935a","842":"64cb521c9962c509c491"}[chunkId] + ".min.js";
};